import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import Switch from "@mui/material/Switch";
import lockedIcon from "images/Locked_icon.png";
import unlockedIcon from "images/Unlocked_icon.png";
import DoneRoundedIcon from "@mui/icons-material/DoneRounded";
import LockRoundedIcon from "@mui/icons-material/LockRounded";
import LockOpenRoundedIcon from "@mui/icons-material/LockOpenRounded";
import { fetchPolicyGroupSettings, updatePolicyGroupSetting, updatePolicySettingLock } from "js/Api/index";
import { Button } from '../../../Component/CommonFormEle';
import { hasValue } from "../../../helpers/common_functions";

function CarerSettings({ user, policy, settingsFrom }) {
    const [settings, setSettings] = useState([]);
    const [career_setting, setcareer_setting] = useState("off");
    const [displaySettings, setdisplaySettings] = useState([]);

    const [selectedRecordingOption, setSelectedRecordingOption] = useState("allow");

    const isReadOnly = selectedRecordingOption !== "manage";

    useEffect(() => {
        fetchSettings();
    }, []);

    const fetchSettings = async () => {
        try {
            const response = await fetchPolicyGroupSettings(policy.id);

            if (response.success) {
                setSettings(response.data.polictSettings);
                setdisplaySettings(response.data.policySettingCategoryGroups);
                updatedisplaySettings(response.data.polictSettings);
                updateSelectedOption(response.data.policySettingCategoryGroups);
            } else {
                console.error("Failed to fetch settings:", response.error);
            }
        } catch (error) {
            console.error("Error fetching settings:", error);
        }
    };

    const updatedisplaySettings = (recordingSettings) => {
        recordingSettings.forEach((setting) => {
            if (setting.friendlyName === "settings.group_leader.carer.mode") {
                setcareer_setting(setting.value);
            }
        });
    };

    const updateSelectedOption = (categoryGroups) => {
        const recordingCategory = categoryGroups.find(
            (category) => category.categoryName === "Carer Mode"
        );
        if (recordingCategory) {
            setSelectedRecordingOption(recordingCategory.locked ? "manage" : "allow");
        }
    };

    const handleSaveSettings = async () => {
        const updatedSettings = [];

        const settings1 = settings.find(setting =>
            setting.friendlyName === "settings.group_leader.carer.mode"
        );

        if (settings1) {
            updatedSettings.push({
                ...settings1,
                value: career_setting.toString()
            });
        }

        try {
            let hasError = false;

            for (const setting of updatedSettings) {
                const response = await updatePolicyGroupSetting(policy.id, setting.id, setting.value);

                if (!response.success) {
                    console.error(`Failed to update setting ${setting.name} (${setting.friendlyName}):`, response.error);
                    hasError = true;
                }
            }

            if (hasError) {
                toast.error("Failed to update settings");
            } else {
                toast.success("Settings updated successfully!");
                fetchSettings();
            }
        } catch (error) {
            console.error("Error updating settings:", error);
            toast.error("Failed to update settings");
        }
    };

    const handleCategoryLockChange = async (locked) => {
        const category = displaySettings.find(
            (category) => category.categoryName === "Carer Mode"
        );

        if (!category) return;

        try {
            const response = await updatePolicySettingLock(policy.id, category.id, locked);

            if (response.success) {
                // Update local state
                category.locked = locked;
                setdisplaySettings([...displaySettings]);
                setSelectedRecordingOption(locked ? "manage" : "allow");
            } else {
                console.error("Failed to update category lock:", response.error);
                toast.error("Failed to update category lock");
            }
        } catch (error) {
            console.error("Error updating category lock:", error);
            toast.error("Failed to update category lock");
        }
    };

    return (
        <>
            <div className="row">
                <div className="col-md-12">
                    <h4 className="d-inline">Carer Mode</h4>
                    <div className="dropdown d-inline">
                        <button className="btn lockerBtn" type="button" data-bs-toggle="dropdown" aria-expanded="false" >
                            {selectedRecordingOption === "allow" ? (
                                <img src={unlockedIcon} style={{ height: "20px" }} />
                            ) : (
                                <img src={lockedIcon} style={{ height: "20px" }} />
                            )}
                        </button>
                        <ul className="dropdown-menu dropdown-item-ul ">
                            <li onClick={() => handleCategoryLockChange(false)}>
                                <span>
                                    <LockOpenRoundedIcon
                                        sx={{
                                            width: "20px",
                                            margin: "0 5px",
                                        }}
                                    />
                                </span>
                                Allow device user and family to change these settings
                                {selectedRecordingOption === "allow" && (
                                    <span style={{ float: "right", marginRight: "1em" }}>
                                        <DoneRoundedIcon />
                                    </span>
                                )}
                            </li>
                            <li onClick={() => handleCategoryLockChange(true)}>
                                <span>
                                    <LockRoundedIcon
                                        sx={{
                                            width: "20px",
                                            margin: "0px 5px",
                                        }}
                                    />
                                </span>
                                Organisation manages these settings
                                {selectedRecordingOption === "manage" && (
                                    <span style={{ float: "right", marginRight: "1em" }}>
                                        <DoneRoundedIcon />
                                    </span>
                                )}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="row mt-2">
                <div className="col-md-12 ml-3">
                    <input
                        className="form-check-input"
                        type="radio"
                        name="flexRadioDefault"
                        id="flexRadioDefault1"
                        checked={career_setting === "on"}
                        onChange={() => setcareer_setting("on")}
                        disabled={isReadOnly}
                    />
                    <label className="form-check-label" htmlFor="flexRadioDefault1" >
                        On
                    </label>
                </div>
            </div>
            <div className="row mt-2">
                <div className="col-md-12 ml-3">
                    <input
                        className="form-check-input"
                        type="radio"
                        name="flexRadioDefault"
                        id="flexRadioDefault2"
                        checked={career_setting === "onhidesetting"}
                        onChange={() => setcareer_setting("onhidesetting")}
                        disabled={isReadOnly}
                    />
                    <label
                        className="form-check-label"
                        htmlFor="flexRadioDefault2"
                    >
                        On, hide settings
                    </label>
                </div>
            </div>
            <div className="row mt-4">
                <div className="col-md-12">
                    <Button onClick={handleSaveSettings} variant="black">
                        Apply
                    </Button>
                </div>
            </div>
        </>
    );
}

export default CarerSettings;